
import { AxiosInstance } from "axios"
import api from "@/services/api"
import { ViewFullSummary } from "@/types/views/viewSummary"
import { View } from "@/types/views/view"

export class ViewsService {
	public viewSummary: ViewFullSummary | null = null;
	public loading: boolean = false;

	public viewError: any = null;
	public activeViewId: string | null = null;
	public activeView: View | null = null;

	public async loadViews (searchTerm: string = "", cacheId: string = "") {
		try {
			this.loading = true
			this.viewError = null

			this.viewSummary = await api.caseViews(this.activeViewId, searchTerm, cacheId)
			this.activeView = this.viewSummary!.activeView

			if (this.activeView) {
				this.activeViewId = this.activeView.id
			}
		} catch (err) {
			this.viewError = err
		}
		this.loading = false
	}

	public reset () {
		this.viewSummary = null
		this.activeView = null
		this.activeViewId = null
	}
}

const viewsService = new ViewsService()
export default viewsService
